import axios from "../../../utils/axios";

export async function fetchJitsiToken(roomName: string) {
    const response = await axios.get(`/generate-jitsi-token`, {
        params: {
            room_name: roomName,
        },
    });

    return response.data;
}
